import BaseScene from '@Scenes/BaseScene';

/*--------------- Core ------------------------*/
import * as Scenes from '@Config/scenes';


class FeatureNotAvailable extends BaseScene
{
    /**
     * Contructor
     */
    constructor()
    {
        super(Scenes.FEATURE_NOT_AVAILABLE)
    }

    /**
     * Creates the scene
     */
    public async create()
    {
        this.cameras.main.setBackgroundColor('rgba(255,255,255,0.95)');

        const gameSize = this.getGameSize();

        this.add.image(gameSize.width / 2, gameSize.height / 2, 'feature_not_available_splash');

        const playNowButton = this.add.image(gameSize.width / 2, (gameSize.height / 2) + 150, 'play_now_black');
        playNowButton.setInteractive();

        const closeButton = this.add.image(gameSize.width - 100, 100, 'close_black');
        closeButton.setInteractive();

        this.input.on('pointerdown', (pointer, targets) =>
        {
            const target = targets[0];

            switch (target)
            {
                case closeButton:
                    this.shutdown();
                    break;
                case playNowButton:
                    this.input.addUpCallback(() =>
                    {
                        window.open('https://fb.gg/play/freeriderjumps', '_blank');
                    }, true)
                    break;
            }

            this.input.stopPropagation();
        }, this)
    }

    /**
     * Shuts down the scene
     */
    public async shutdown()
    {
        this.scene.stop(Scenes.FEATURE_NOT_AVAILABLE);
    }
}

export default FeatureNotAvailable;